import { Flex, Image } from "@chakra-ui/react";
import roadmapIcon from "../../../assets/aimon/roadmap.png";
import roadmapMobileIcon from "../../../assets/aimon/roadmap_mobile.png";
import styles from "./Roadmap.module.scss";
export default function Roadmap() {
  const isMobile = window.innerWidth < 768;
  return (
    <Flex className={styles.container} id="roadmap">
      <Flex className={styles.title}>Roadmap</Flex>
      <Flex className={styles.contentGroup}>
        <Image src={isMobile ? roadmapMobileIcon : roadmapIcon} alt="logo" />
      </Flex>
    </Flex>
  );
}
